import { render, staticRenderFns } from "./taskAdder.vue?vue&type=template&id=04e69430&"
import script from "./taskAdder.vue?vue&type=script&lang=js&"
export * from "./taskAdder.vue?vue&type=script&lang=js&"
import style0 from "./taskAdder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports